export const isWhatsAppResetEnabled = () => import.meta.env.VITE_WHATSAPP_RESET_ENABLED === 'true';
